/**
 * The character level (2.H deliverable 3), alone in its module so the header pill, which every
 * page's header loads, reaches no derive code.
 */
import type { CharacterV1 } from '@codex/dnd5e/schema';

/** The sum of the class levels. */
export function characterLevel(data: CharacterV1): number {
  return data.classes.reduce((sum, c) => sum + c.levels, 0);
}
